import styled from 'styled-components';

interface IProps {
    color: string;
}

export const BackgroundColorWrapper = styled.div<IProps>`
    background-color: ${({ color }) => color};
    transition: background-color 300ms ease-in-out;
`;
